import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NvMatTooltipModule } from '../../../shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { ListSearchComponent } from './list-search.component';

@NgModule({
  declarations: [ListSearchComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NvMatTooltipModule],
  providers: [],
  exports: [ListSearchComponent],
})
export class ListSearchModule {
  //
}
